import React, { Component } from "react";
import { getAnalyticsData } from "apis";
import {
  FormContainer,
  Form,
  H1,
  Grid,
  GridItem,
  FlexColumn,
  P,
} from "appStyles";
import CountUp from "react-countup";
import { priceToDollars } from "helpers";

class App extends Component {
  state = {};

  componentDidMount() {
    const {
      activeApp: { id },
    } = this.props;

    getAnalyticsData(id).then((res) => {
      const { id, appId, ...data } = res;

      this.setState({
        ...data,
        totalCashCreditRedeemed: `$${
          data.totalCashCreditRedeemed
            ? data.totalCashCreditRedeemed.toFixed(2)
            : "0.00"
        }`,
        lifetimeOrderTotal: `${
          data.lifetimeOrderTotal
            ? priceToDollars(data.lifetimeOrderTotal)
            : "0.00"
        }`,
      });
    });
  }

  renderDataTiles = () => {
    return dataTitles.map((el) => {
      const { type, title } = el;
      // console.log(type);

      if (this.state[type] === undefined) return;

      return (
        <GridItem
          key={el.type}
          margin="10px auto 10px 20px"
          width="20em"
          height="10em"
          boxShadow="5px 5px 10px #cecece"
          border="1px solid black"
          background="white"
        >
          <FlexColumn>
            <P color="#2583e8" fontSize="2.5em">
              {/* {this.state[type]} */}
              <CountUp end={this.state[type]} />
            </P>
            <P fontSize="1.2em" color="#2583e8" marginTop="1em">
              {title}
            </P>
          </FlexColumn>
        </GridItem>
      );
    });
  };

  render() {
    return <Grid columns={3}>{this.renderDataTiles()}</Grid>;
  }
}

const dataTitles = [
  {
    type: "appOpenedCount",
    title: "App Opens",
  },
  {
    type: "totalUsersWithSaved",
    title: "App Downloads",
  },
  {
    type: "totalUsersWithNotifications",
    title: "Notifications On",
  },
  {
    type: "totalUsersWithFavorites",
    title: "App Favorited",
  },
  {
    type: "lifetimeOrders",
    title: "Lifetime Orders",
  },

  {
    type: "lifetimeOrderTotal",
    title: "Lifetime Sales",
  },
  {
    type: "dealsRedeemed",
    title: "Deals Redeemed",
  },
  {
    type: "dealsPageViewedCount",
    title: "Deals Page Views",
  },
  {
    type: "rewardsRedeemed",
    title: "Rewards Redeemed",
  },
  {
    type: "rewardsPageViewedCount",
    title: "Rewards Page Views",
  },

  {
    type: "numberOfTimesCashCreditRedeemed",
    title: "Cash Credit Redeemed Count",
  },
  {
    type: "totalCashCreditRedeemed",
    title: "Cash Credit Redeemed",
  },

  {
    type: "homePageTotalVisitorCount",
    title: "Total Mobile360 Visits",
  },
];

export default App;
